// Message Constants for Services Admin Panel
export const SERVICE_CREATED_SUCCESSFULLY = 'Service created successfully.';
export const SERVICE_COULDNT_CREATED = 'Service could not be created.';
export const SERVICE_UPDATED_SUCCESSFULLY = 'Service updated successfully.';
export const SERVICE_COULDNT_UPDATED = 'Service could not be updated.';
export const SERVICE_DELETED_SUCCESSFULLY = 'Service deleted successfully.';
export const SERVICE_COULDNT_DELETED = 'Service could not be deleted.';
export const SERVICE_STATUS_UPDATED_SUCCESSFULLY = 'Service status updated successfully.';
export const SERVICE_STATUS_COULDNT_UPDATED = 'Service status could not be updated.';

// Message Constants for Plans Admin Panel
export const PLAN_CREATED_SUCCESSFULLY = 'Plan created successfully.';
export const PLAN_COULDNT_CREATED = 'Plan could not be created.';
export const PLAN_DELETED_SUCCESSFULLY = 'Plan deleted successfully.';
export const PLAN_COULDNT_DELETED = 'Plan could not be deleted.';
export const PLAN_STATUS_UPDATED_SUCCESSFULLY = 'Plan status updated successfully.';
export const PLAN_STATUS_COULDNT_UPDATED = 'Plan status could not be updated.';

// Message Constants for Packages Admin Panel
export const PACKAGE_CREATED_SUCCESSFULLY = 'Package created successfully.';
export const PACKAGE_COULDNT_CREATED = 'Package could not be created.';
export const PACKAGE_DELETED_SUCCESSFULLY = 'Package deleted successfully.';
export const PACKAGE_COULDNT_DELETED = 'Package could not be deleted.';
export const PACKAGE_STATUS_UPDATED_SUCCESSFULLY = 'Package status updated successfully.';
export const PACKAGE_STATUS_COULDNT_UPDATED = 'Package status could not be updated.';

// Message Constants for Memberships Admin Panel
export const MEMBERSHIP_CREATED_SUCCESSFULLY = 'Membership created successfully.';
export const MEMBERSHIP_COULDNT_CREATED = 'Membership could not be created.';
export const MEMBERSHIP_DELETED_SUCCESSFULLY = 'Membership deleted successfully.';
export const MEMBERSHIP_COULDNT_DELETED = 'Membership could not be deleted.';
export const MEMBERSHIP_STATUS_UPDATED_SUCCESSFULLY = 'Membership status updated successfully.';
export const MEMBERSHIP_STATUS_COULDNT_UPDATED = 'Membership status could not be updated.';

// Message Constants for Users Admin Panel
export const ADMIN_CREATED_SUCCESSFULLY = 'Admin created successfully.';
export const ADMIN_STATUS_CHANGED_ENABLED = 'Admin Enabled';
export const ADMIN_STATUS_CHANGED_DISABLED = 'Admin Disabled';
export const ADMIN_DELETED= 'Admin Deleted'

export const CLASS_STATUS_UPDATED = "Class status updated successfully.";


// Message Constants for Yoga Class Plans
export const YOGA_CLASS_PLAN_CREATED_SUCCESSFULLY = 'Yoga class plan created successfully.';
export const YOGA_CLASS_PLAN_COULDNT_CREATED = 'Yoga class plan could not be created.';
export const YOGA_CLASS_PLAN_UPDATED_SUCCESSFULLY = 'Yoga class plan updated successfully.';
export const YOGA_CLASS_PLAN_COULDNT_UPDATED = 'Yoga class plan could not be updated.';
export const YOGA_CLASS_PLAN_DELETED_SUCCESSFULLY = 'Yoga class plan deleted successfully.';
export const YOGA_CLASS_PLAN_COULDNT_DELETED = 'Yoga class plan could not be deleted.';
export const YOGA_CLASS_PLAN_STATUS_UPDATED_SUCCESSFULLY = 'Yoga class plan status updated successfully.';
export const YOGA_CLASS_PLAN_STATUS_COULDNT_UPDATED = 'Yoga class plan status could not be updated.';

// Message Constants for Hot Yoga Class Plans
export const HOT_YOGA_CLASS_PLAN_CREATED_SUCCESSFULLY = 'Hot yoga class plan created successfully.';
export const HOT_YOGA_CLASS_PLAN_COULDNT_CREATED = 'Hot yoga class plan could not be created.';
export const HOT_YOGA_CLASS_PLAN_UPDATED_SUCCESSFULLY = 'Hot yoga class plan updated successfully.';
export const HOT_YOGA_CLASS_PLAN_COULDNT_UPDATED = 'Hot yoga class plan could not be updated.';
export const HOT_YOGA_CLASS_PLAN_DELETED_SUCCESSFULLY = 'Hot yoga class plan deleted successfully.';
export const HOT_YOGA_CLASS_PLAN_COULDNT_DELETED = 'Hot yoga class plan could not be deleted.';
export const HOT_YOGA_CLASS_PLAN_STATUS_UPDATED_SUCCESSFULLY = 'Hot yoga class plan status updated successfully.';
export const HOT_YOGA_CLASS_PLAN_STATUS_COULDNT_UPDATED = 'Hot yoga class plan status could not be updated.';

// Message Constants for Meditation Class Plans
export const MEDITATION_CLASS_PLAN_CREATED_SUCCESSFULLY = 'Meditation class plan created successfully.';
export const MEDITATION_CLASS_PLAN_COULDNT_CREATED = 'Meditation class plan could not be created.';
export const MEDITATION_CLASS_PLAN_UPDATED_SUCCESSFULLY = 'Meditation class plan updated successfully.';
export const MEDITATION_CLASS_PLAN_COULDNT_UPDATED = 'Meditation class plan could not be updated.';
export const MEDITATION_CLASS_PLAN_DELETED_SUCCESSFULLY = 'Meditation class plan deleted successfully.';
export const MEDITATION_CLASS_PLAN_COULDNT_DELETED = 'Meditation class plan could not be deleted.';
export const MEDITATION_CLASS_PLAN_STATUS_UPDATED_SUCCESSFULLY = 'Meditation class plan status updated successfully.';
export const MEDITATION_CLASS_PLAN_STATUS_COULDNT_UPDATED = 'Meditation class plan status could not be updated.';

// PAGE MESSAGES GENERIC
export const PAGE_UPDATED_SUCCESSFULLY = 'Page updated successfully.'

// Message Constants for Image updation
export const IMAGE_UPDATED_SUCCESSFULLY = 'Image updated successfully.';

// Message Constants for Instructors
export const INSTRUCTOR_CREATED_SUCCESSFULLY = 'Instructor created successfully.';
export const INSTRUCTOR_COULDNT_CREATED = 'Instructor could not be created.';
export const INSTRUCTOR_UPDATED_SUCCESSFULLY = 'Instructor updated successfully.';
export const INSTRUCTOR_COULDNT_UPDATED = 'Instructor could not be updated.';
export const INSTRUCTOR_DELETED_SUCCESSFULLY = 'Instructor deleted successfully.';
export const INSTRUCTOR_COULDNT_DELETED = 'Instructor could not be deleted.';
export const INSTRUCTOR_STATUS_UPDATED_SUCCESSFULLY = 'Instructor status updated successfully.';
export const INSTRUCTOR_STATUS_COULDNT_UPDATED = 'Instructor status could not be updated.';